import PropTypes from "prop-types"
import classNames from "classnames"
import moment from "moment"
import { map, filter } from "lodash"
import { Card, CardContent, Chip, Typography, Button } from "@mui/material"
import { Label as LabelIcon } from "@mui/icons-material"
import BundleChip from "../bundleChip"
import { getTags } from "modules/data-cloud/helpers"

import "../style.scss"

const Bundle = (props) => {
  const { dataset, style, state, preheader, subheader, actions, toggleExpanded, contactUs } = props
  const { expanded } = state
  const { id, name, description, datasets } = dataset || {}

  return <div className="stack dataset bundle" onClick={toggleExpanded}>
    <Card square className={classNames("dataset browse bundle", { condensed: !expanded, expanded })} style={style}>
      <div className="back" />
      <div className="back" />
      <div className="front">
        <div className="header">
          <div className="title">
            {preheader}
            <Typography variant="h5" component="h5">{name || id}</Typography>
            {subheader}
          </div>

          <div className="actions">
            {actions}
          </div>
        </div>
        <CardContent className="content">
          <p className="description">{description}</p>
          <div className="bottom-bar">
            <div className="chips">
              <BundleChip datasets={datasets} />
              {map(getTags(datasets), ({ type, value, display }) => {
                // Default is no display prop so we need to check explicitly for the bool false value
                if (display === false) { return null }
                switch (type) {
                  case "publisher":
                    return <Chip key={value} label={<span>Published by <b>{value}</b></span>} />
                  default:
                    return <Chip key={value} className="type" avatar={<LabelIcon />} label={value} />
                }
              })}
            </div>
            {// if at least one item has a expiration dates AND all the items with expiration dates  are not expired
              datasets.some(({ expiration }) => expiration) && !filter(datasets, ({ expiration }) => expiration).every(({ expiration }) => moment(expiration).isBefore(moment()))
                ? <Button variant="contained" disabled>Subscribed</Button>
                : <Button className="cta" variant="contained" color="primary" onClick={contactUs}>Contact Us</Button>
            }
          </div>
        </CardContent>
      </div>
    </Card>
  </div>
}

Bundle.propTypes = {
  dataset: PropTypes.object.isRequired,
  state: PropTypes.shape({
    expanded: PropTypes.bool,
    favourite: PropTypes.bool,
    notifications: PropTypes.bool,
  }).isRequired,
  style: PropTypes.object,
  actions: PropTypes.object,
  preheader: PropTypes.object,
  subheader: PropTypes.object,
  toggleExpanded: PropTypes.func.isRequired,
  contactUs: PropTypes.func.isRequired,
}
export default Bundle
